import { render, staticRenderFns } from "./PartnerWorldMap.vue?vue&type=template&id=6853dcec&scoped=true"
import script from "./PartnerWorldMap.vue?vue&type=script&lang=js"
export * from "./PartnerWorldMap.vue?vue&type=script&lang=js"
import style0 from "./PartnerWorldMap.vue?vue&type=style&index=0&id=6853dcec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6853dcec",
  null
  
)

export default component.exports